export enum FrameShape {
  Circle = 0,
  Square = 1,
  Rectangle = 2
}

export function frameShapeCssClass(val: FrameShape): string {
  return FrameShape[val].toLowerCase()
}

